import axios from '@/utils/axios'
const rootUrl = 'masterdata/website/field/'
const api = {
  GetAllFields: rootUrl + 'getAllFields',
  GetPage: rootUrl + 'getPage',
  Getlist: rootUrl + 'getlist',
  DelFd: rootUrl + 'delFd',
  AddNewFd: rootUrl + 'addNewFd',
  ModifyFd: rootUrl + 'modifyFd',
  GetDetail: rootUrl + 'getDetail',
  GetImportGoods: rootUrl + 'getImportGoods',
  SetImportGoods: rootUrl + 'setImportGoods'
}

/**
 * 档案分类下所有字段接口
 * (终端自定义字段)
 */
export function getAllFields(cls_id, scene_way = '') {
  return axios.formRequest.post(api.GetAllFields, { cls_id, scene_way })
}

/**
 * 字段列表接口(分页)
 */
export function getPage(parameter) {
  return axios.formRequest.post(api.GetPage, parameter)
}
/**
 * 字段列表接口
 */
export function getlist(field_class) {
  return axios.formRequest.post(api.Getlist, { field_class })
}
/**
 * 字段删除接口
 */
export function delFd(field_id, function_name) {
  return axios.formRequest.post(api.DelFd, { field_id, function_name })
}
/**
 * 字段添加接口
 */
export function addNewFd(parameter) {
  return axios.formRequest.post(api.AddNewFd, parameter)
}

/**
 * 字段编辑接口
 */
export function modifyFd(parameter) {
  return axios.formRequest.post(api.ModifyFd, parameter)
}

/**
 * 字段详情接口
 */
export function getDetail(field_id) {
  return axios.formRequest.post(api.GetDetail, { field_id })
}

/**
 * 获取导入产品配置接口
 */
export function getImportGoods() {
  return axios.formRequest.post(api.GetImportGoods, {})
}

/**
 * 档案导入配置接口
 */
export function setImportGoods(type) {
  return axios.formRequest.post(api.SetImportGoods, { type })
}
/**
 * 编辑字段APP是否显示
 */
export function appEdit(parameter) {
  return axios.formRequest.post('masterdata/website/field/appEdit', parameter)
}

/**
 * 档案字段编辑
 * title_list
 * field_list
 */
export function modifyField(parameter) {
  return axios.formRequest.post(
    'masterdata/website/field/modifyField',
    parameter
  )
}

/**
 * 档案字段排序列表
 */
export function titleSortList(cls) {
  return axios.formRequest.post('masterdata/website/field/titleSortList', {
    cls
  })
}

/**
 * 档案字段排序保存
 */
export function modifyAppSort(titleSortList) {
  return axios.formRequest.post('masterdata/website/field/modifyAppSort', {
    titleSortList
  })
}

/**
 * 设置tab栏
 */
export function crmTabSet(parameter) {
  return axios.formRequest.post('crm/website/setting/crmTabSet', parameter)
}

/**
 * 修改系统字段名称
 */
export function settingAsiaTitle(parameter) {
  return axios.formRequest.post(
    'masterdata/website/title_sort/settingAsiaTitle',
    parameter
  )
}

/**
 * 获取档案系统字段
 */
export function fledList(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getWebClientField',
    parameter
  )
}

/**
 * 获取等级
 */
export function clientLevelList(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/clientLevelList',
    parameter
  )
}

/**
 * 修改等级
 */
export function changeClientLevel(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/changeClientLevel',
    parameter
  )
}

/**
 * 修改档案标签
 */
export function changeClientLabel(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/changeClientLabel',
    parameter
  )
}

/**
 * 数据标签名列表
 */
export function getDataLabelList(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/dataLabelList',
    parameter
  )
}

/**
 * 信用代码重复配置
 */
export function setCreditRepeat(parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/setCreditRepeat',
    parameter
  )
}

/**
 * 获取信用代码重复配置
 */
export function getCreditRepeat(parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/getCreditRepeat',
    parameter
  )
}

/**
 * 档案字段回传对照-华神
 */
export function getHuaShenList(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client_custom_conf/getList',
    parameter
  )
}

/**
 * 档案字段回传对照保存
 */
export function saveConf(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client_custom_conf/saveConf',
    parameter
  )
}


/**
 * 获取拉伸表格宽度存储
 */
 export function getTableTitleMap(parameter) {
  return axios.formRequest.post(
    'masterdata/website/Field/getTableTitleMap',
    parameter
  )
}
/**
 * 设置拉伸表格宽度存储
 */
 export function setTableTitleMap(parameter) {
  return axios.formRequest.post(
    'masterdata/website/Field/setTableTitleMap',
    parameter
  )
}

